import { Box, Dialog, DialogActions, DialogContent, Divider, IconButton, Typography } from "@mui/material"
import { CloseOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import React from "react"

import { AssociatedProductsTable } from "../tables/AssociatedProductsTable"

import { Button } from "@/components/common/Button"
import type { InstructionProduct } from "@/graphql/codegen/graphql"

interface DeactivateInstructionWarningProps {
  onClose: () => void
  onSubmit: () => void
  products: InstructionProduct[]
  productsFetching: boolean
}

const DeactivateInstructionWarning: React.FC<DeactivateInstructionWarningProps> = ({
  onClose,
  onSubmit,
  products,
  productsFetching,
}) => {
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth='lg'>
      <IconButton aria-label='close' onClick={onClose} className='absolute right-4 top-4 text-primary'>
        <CloseOutlined />
      </IconButton>
      <Divider />
      <DialogContent classes={{ root: "p-10 flex flex-col gap-6" }}>
        <Box className='flex justify-center'>
          <WarningOutlined className='size-[48px] text-secondary-600' />
        </Box>
        <Typography color='primary' variant='h5' align='center'>
          Are you sure you want to deactivate this instruction?
        </Typography>
        <Typography align='center' className='mt-6 px-3 text-base leading-[150%] tracking-[-0.85px] text-gray-700'>
          By making this instruction inactive the system will automatically remove the products association with the
          instructions.
          <br /> Review the list of products below and click on “Deactivate” if you want to proceed to remove them from
          it or “Go Back” if this action was a mistake.
        </Typography>
        <AssociatedProductsTable products={products} productsFetching={productsFetching} />
      </DialogContent>
      <DialogActions className='justify-between px-10 pb-10'>
        <Button appearance='outlined' onClick={onClose}>
          Go Back
        </Button>
        <Button onClick={onSubmit} variant={"error"}>
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeactivateInstructionWarning
